import { hasClientSession } from '../services/session';
// audit-safety-integrated
import { readJson } from '../utils/auditSafety';
import React, { useEffect, useState, useRef } from 'react';
import {
  Users,
  ShoppingCart,
  CalendarDays,
  TrendingUp,
  Building2,
  BellDot,
  Package,
  Activity,
  BarChart3,
  Clock,
  CheckCircle2,
  AlertCircle,
  Eye,
  ArrowUpRight,
  ArrowDownRight,
  Truck,
  FileText
} from 'lucide-react';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import '../fonts/NotoSansTamil-VariableFont_wdth,wght-normal.js';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router-dom";
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { enUS } from "date-fns/locale";
import { API_BASE_URL } from '../services/api';
const SimplifiedDashboard = () => {
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState('');
  const [showVegAlert, setShowVegAlert] = useState(false);
  const [storeData, setStoreData] = useState(null);
  const [orderReport, setOrderReport] = useState([]);
  const [recentIndents, setRecentIndents] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [storeDetails, setStoreDetails] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [storesData, setStoresData] = useState([]);
const [selectedDepartment, setSelectedDepartment] = useState('');
const [storeStatsSortBy, setStoreStatsSortBy] = useState('pending-desc');
 // Default Prison Department
  const [branchesModalOpen, setBranchesModalOpen] = useState(false);
  const [selectedBranches, setSelectedBranches] = useState(null);
  const [filteredIndents, setFilteredIndents] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState('thisMonth');   // Default period
  const [customRange, setCustomRange] = useState({ start: null, end: null });
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);
  const [departments, setDepartments] = useState([]);
const [indAprStoreInfo, setIndAprStoreInfo] = useState(null);
const [indAprStoreLoading, setIndAprStoreLoading] = useState(false);
const [storeStatsData, setStoreStatsData] = useState([]);
const [storeStatsLoading, setStoreStatsLoading] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [customLabel, setCustomLabel] = useState(''); // for showing “Oct 1 – Oct 10”
const handleCardClick = (status) => {
  let params = new URLSearchParams();

  // ✅ Map card keys to correct tabs
  let tab;
  if (status === 'approved') {
    tab = 'approved'; // Orders received by admin (backend status: "Approved")
  } else if (status === 'dispatch') {
    tab = 'dispatch'; // Orders dispatched (backend status: "Dispatch")
  } else if (status === 'received' || status === 'pc' || status === 'invoice' || status === 'payment') {
    tab = 'received'; // Completed orders (backend status: "Received")
  } else {
    tab = status;
  }

  params.append('tab', tab);

  // Add filter for specific statuses
  if (status === 'pc') {
    params.append('filter', 'pc-pending');
  } else if (status === 'invoice') {
    params.append('filter', 'invoice-pending');
  } else if (status === 'payment') {
    params.append('filter', 'payment-pending');
  }

  // Add store filter if selected
  if (selectedDistrict) {
    const selectedStoreObj = storesData.find(store => store.name === selectedDistrict);
    if (selectedStoreObj) {
      params.append('store', selectedStoreObj.name);
    }
  }

// ✅ FIXED (dynamic, no flow change)
if (selectedDepartment) {
  const selectedDeptObj = departments.find(
    dept => String(dept.id) === String(selectedDepartment)
  );

  if (selectedDeptObj) {
    params.append('department', selectedDeptObj.name);
  }
}


  // ✅ Pass dep-rep filters (type and branch)
  if (userRole === 'dep-rep') {
    if (selectedType) params.append('type', selectedType);
    if (selectedBranch) params.append('branch', selectedBranch);
  }

  // Add period filter
  if (selectedPeriod) {
    if (selectedPeriod === "custom" && dateRange[0]?.startDate && dateRange[0]?.endDate) {
      const start = dateRange[0].startDate.toISOString().split("T")[0];
      const end = dateRange[0].endDate.toISOString().split("T")[0];
      params.append('period', `${start}:${end}`);
    } else if (selectedPeriod !== "custom") {
      params.append('period', selectedPeriod);
    }
  }

  void 0;
  navigate(`/indent-request?${params.toString()}`);
};
  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      setUserName(user.name || '');
      setUserRole(user.role || '');
      if (user.role === 'rcs-store') {
        const alertDate = localStorage.getItem('showVegPriceAlert');
        if (alertDate === new Date().toDateString()) {
          setShowVegAlert(true);
        }
      }
    }
  }, []);

  useEffect(() => {
    const fetchDepartments = async () => {
      const sessionAvailable = hasClientSession();
      if (!sessionAvailable) return;

      try {
        const res = await fetch(
          `${API_BASE_URL}/user/departments`,
          {
            method: "GET",
            headers: {

              "Content-Type": "application/json",
            },
          }
        );

        const result = await readJson(res);
        if (!result.error) {
          setDepartments(result.data || []);
        } else {
          void 0;
        }
      } catch (err) {
        void 0;
      }
    };

    fetchDepartments();
  }, []);


// Replace the useEffect with this corrected version
useEffect(() => {
  const fetchIndAprStoreInfo = async () => {
    void 0;
    void 0;

    if (userRole !== 'ind-apr' && userRole !== 'st-ind-apr') {
      void 0;
      return;
    }

    const sessionAvailable = hasClientSession();

    if (!sessionAvailable) {
      void 0;
      return;
    }

    setIndAprStoreLoading(true);

    try {
      // 🔥 STEP 1: First fetch /user/departments to get store code
      void 0;

      const deptResponse = await fetch(
        `${API_BASE_URL}/user/departments`,
        {
          method: 'GET',
          headers: {

            'Content-Type': 'application/json',
          },
        }
      );

      const deptResult = await readJson(deptResponse);
      void 0;

      const storeCode = deptResult?.user?.detail?.store;
      void 0;

      if (!storeCode) {
        void 0;
        setIndAprStoreLoading(false);
        return;
      }

      // 🔥 STEP 2: Now fetch store details using the store code
      const apiUrl = `${API_BASE_URL}/user/store/${storeCode}`;
      void 0;

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {

          'Content-Type': 'application/json',
        },
      });

      void 0;

      const result = await readJson(response);
      void 0;

      if (response.ok && !result.error) {
        setIndAprStoreInfo(result.data);
        void 0;
      } else {
        void 0;
      }
    } catch (err) {
      void 0;
    } finally {
      setIndAprStoreLoading(false);
    }
  };

  fetchIndAprStoreInfo();
}, [userRole]);


  useEffect(() => {
    const fetchDashboardData = async () => {
      const sessionAvailable = hasClientSession();
      if (!sessionAvailable) {
        void 0;
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/master/report/store-data`,
          {
            method: 'GET',
            headers: {

              'Content-Type': 'application/json',
            },
          }
        );

        const result = await readJson(response);
        if (response.ok && !result.error) {
          setStoreData(result.data);
          void 0;
        } else {
          void 0;
        }
      } catch (err) {
        void 0;
      }
    };

    fetchDashboardData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };
    if (showCalendar) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showCalendar]);

  useEffect(() => {
    const fetchRecentIndents = async () => {
      const sessionAvailable = hasClientSession();
      if (!sessionAvailable) {
        void 0;
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/indent/report/recent?limit=5`,
          {
            method: 'GET',
            headers: {

              'Content-Type': 'application/json',
            },
          }
        );
        const result = await readJson(response);
        if (response.ok && !result.error) {
          setRecentIndents(result.data || []);
          void 0;
        } else {
          void 0;
        }
      } catch (err) {
        void 0;
      }
    };
    fetchRecentIndents();
  }, []);
  const totalOrders = orderReport.reduce((acc, item) => acc + (item.orders || 0), 0);
  const receivedOrders = orderReport.reduce((acc, item) => acc + (parseInt(item.received) || 0), 0);
  const dispatchedOrders = orderReport.reduce((acc, item) => acc + (parseInt(item.dispatched) || 0), 0);
  const completedOrders = orderReport.reduce((acc, item) => acc + (parseInt(item.completed) || 0), 0);
  const pcOrders = orderReport.reduce((acc, item) => acc + (parseInt(item.pc) || 0), 0);
  const invoiceOrders = orderReport.reduce((acc, item) => acc + (parseInt(item.invoice) || 0), 0);
  const paidOrders = orderReport.reduce((acc, item) => acc + (parseInt(item.paid) || 0), 0);

  // Calculate pending values
  const pendingOrders = totalOrders - receivedOrders;
  const pcPending = pcOrders - totalOrders;
  const invoicePending = invoiceOrders - totalOrders;
  const paymentPending = paidOrders - totalOrders;
  const summaryCards = [
    {
      key: 'approved',
      title: userRole === 'dep-rep' ? 'Order Placed' : 'Orders',
      value: `${receivedOrders}/${totalOrders}`,
      icon: <ShoppingCart className="w-7 h-7 text-emerald-600" />,
      color: 'from-emerald-500 to-emerald-600',
      bgColor: 'bg-emerald-50',
    },
    {
      key: 'dispatch',
      title: 'Dispatched',
      value: dispatchedOrders,
      icon: <Truck className="w-7 h-7 text-amber-600" />,
      color: 'from-amber-500 to-amber-600',
      bgColor: 'bg-amber-50',
    },
    {
      key: 'received',
      title: 'Completed',
      value: completedOrders,
      icon: <FileText className="w-7 h-7 text-blue-600" />,
      color: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      key: 'pc',
      title: 'PC',
      // ✅ completedOrders - pcOrders / completedOrders
      value: `${completedOrders - pcOrders}/${completedOrders}`,
      icon: <FileText className="w-7 h-7 text-purple-600" />,
      color: 'from-purple-500 to-purple-600',
      bgColor: 'bg-purple-50',
    },
    {
      key: 'invoice',
      title: 'Invoice',
      // ✅ pcOrders - invoiceOrders / pcOrders
      value: `${pcOrders - invoiceOrders}/${pcOrders}`,
      icon: <FileText className="w-7 h-7 text-pink-600" />,
      color: 'from-pink-500 to-pink-600',
      bgColor: 'bg-pink-50',
    },
    {
      key: 'payment',
      title: 'Payment ',
      // ✅ invoiceOrders - paidOrders / invoiceOrders
      value: `${invoiceOrders - paidOrders}/${invoiceOrders}`,
      icon: <FileText className="w-7 h-7 text-green-600" />,
      color: 'from-green-500 to-green-600',
      bgColor: 'bg-green-50',
    },
  ];
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'approved':
      case 'completed':
      case 'active':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'processing':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'inactive':
        return 'bg-gray-100 text-gray-800 border-gray-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority.toLowerCase()) {
      case 'high':
        return 'bg-red-100 text-red-800';
      case 'medium':
        return 'bg-yellow-100 text-yellow-800';
      case 'low':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success':
        return <CheckCircle2 className="w-4 h-4 text-green-500" />;
      case 'warning':
        return <AlertCircle className="w-4 h-4 text-yellow-500" />;
      case 'info':
        return <Activity className="w-4 h-4 text-blue-500" />;
      default:
        return <BellDot className="w-4 h-4" />;
    }
  };

  const handleStoreClick = async (storeCode, storeName) => {
    const sessionAvailable = hasClientSession();
    if (!sessionAvailable) {
      void 0;
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/master/detail/${storeCode}/store-data`,
        {
          method: 'GET',
          headers: {

            'Content-Type': 'application/json',
          },
        }
      );
      const result = await readJson(response);
      if (response.ok && !result.error) {
        setSelectedStore(storeName); // This shows user-friendly name in modal
        setStoreDetails(result.data || {});
        setIsModalOpen(true);
      } else {
        void 0;
      }
    } catch (err) {
      void 0;
    }
  };
const downloadStoreStatsExcel = () => {
  if (!storeStatsData || storeStatsData.length === 0) {
    void 0;
    return;
  }

  // Filter out null stores and prepare data for Excel
  const worksheetData = storeStatsData
    .filter((item) => item.store !== null)
    .map((store, index) => ({
      "S.No": index + 1,
      "Store Code": store.code || "N/A",
      "Store Name": store.store || "Unknown",
      "Received": store.received || 0,
      "Dispatched": store.dispatched || 0
    }));

  // Convert to worksheet
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);

  // Set column widths
  worksheet["!cols"] = [
    { wch: 10 },  // S.No
    { wch: 20 },  // Store Code
    { wch: 40 },  // Store Name
    { wch: 12 },  // Received
    { wch: 12 }   // Dispatched
  ];

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Store Stats");

  // Export as Excel
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Generate filename with current date
  const today = new Date().toISOString().split('T')[0];
  saveAs(blob, `store_stats_${today}.xlsx`);

  void 0;
};
  const downloadStoreExcel = () => {
    if (!storeDetails || !storeDetails.items) return;

    // Prepare data for Excel
    const worksheetData = storeDetails.items.map((item, index) => ({
      "S.No": index + 1,
      "Item Name": `${item.name} ${item.unit ? `(${item.unit})` : ""}`,
      "Rate (₹)": item.rate,
      "Pack Size": `${item.pack || ""} ${item.pack_unit || ""}`,
    }));

    // Convert to worksheet
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Store Data");

    // Export as Excel
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${selectedStore}_store_data.xlsx`);

  };
  const handleBranchClick = (store) => {
    if (store.branches && store.branches.length > 0) {
      setSelectedBranches({
        storeName: store.store,
        branches: store.branches
      });
      setBranchesModalOpen(true);
    }
  };
const handlePriceItemsExcel = async () => {
  const sessionAvailable = hasClientSession();
  if (!sessionAvailable) {
    void 0;
    return;
  }

  try {
    const response = await fetch(
      `${API_BASE_URL}/master/detail/rate/full-comparison`,
      {
        method: "GET",
        headers: {

          "Content-Type": "application/json",
        },
      }
    );

    const result = await readJson(response);

    if (response.ok && !result.error) {
      const data = result.data || [];

      // 🔥 Separate data by category
      const foodItems = data.filter(item => item.category === "food");
      const dailyItems = data.filter(item => item.category === "dailie");

      // 🔥 Find all city keys dynamically (excluding id, name, unit, category)
      const cityKeys = Object.keys(data[0] || {}).filter(
        (key) => !["id", "name", "unit", "category"].includes(key)
      );

      // 🔥 Function to create worksheet data with brand filtering
      const createWorksheetDataWithMerge = (items, brandFilter = null) => {
        let headers1 = []; // Main header row (store names)
        let headers2 = []; // Sub header row (Min/Max)

        if (brandFilter === "Non-JPC" || brandFilter === "Unknown") {
          // Row 1: S.No spans 1 column, Item Name spans 1 column, each city spans 2 columns
          headers1 = ["S.No", "Item Name / Unit"];
          headers2 = ["", ""]; // Empty for S.No and Item Name

          cityKeys.forEach(city => {
            headers1.push(city, ""); // City name, then empty (will be merged)
            headers2.push("Min", "Max"); // Sub-headers
          });
        }

        const rows = [];

        items.forEach((item, index) => {
          const row = [
            index + 1, // S.No
            `${item.name} (${item.unit})`, // Name + Unit
          ];

          // Add city values in same order
          cityKeys.forEach((city) => {
            const cityData = item[city];

            // ✅ Handle string values (direct price)
            if (typeof cityData === 'string' || typeof cityData === 'number') {
              row.push(cityData, cityData); // Same value for min & max
              return;
            }

            // ✅ Handle empty/null values
            if (!cityData || !Array.isArray(cityData) || cityData.length === 0) {
              row.push("-", "-");
              return;
            }

            // Find matching brand_type
            let brandData;

            if (brandFilter === "Non-JPC") {
              brandData = cityData.find(d => d.brand_type === "Non-JPC");
            } else if (brandFilter === "Unknown") {
              brandData = cityData.find(d => d.brand_type === "Unknown");
            } else {
              brandData = cityData.find(d => d.brand_type === brandFilter);
            }

            if (brandData) {
              const rate = brandData.rate;

              if (Array.isArray(rate) && rate.length >= 2) {
                row.push(rate[0] || "-", rate[1] || "-"); // Min, Max
              } else if (Array.isArray(rate) && rate.length === 1) {
                row.push(rate[0] || "-", rate[0] || "-"); // Same value
              } else {
                row.push(rate || "-", rate || "-"); // Single value
              }
            } else {
              row.push("-", "-");
            }
          });

          rows.push(row);
        });

        return { headers1, headers2, rows };
      };

      // 🔥 Regular function for other sheets (no merge)
      const createWorksheetData = (items, brandFilter = null) => {
        const headers = ["S.No", "Item Name / Unit", ...cityKeys];
        const rows = [];

        items.forEach((item, index) => {
          const row = [
            index + 1,
            `${item.name} (${item.unit})`,
          ];

          cityKeys.forEach((city) => {
            const cityData = item[city];

            if (typeof cityData === 'string' || typeof cityData === 'number') {
              row.push(cityData);
              return;
            }

            if (!cityData || !Array.isArray(cityData) || cityData.length === 0) {
              row.push("-");
              return;
            }

            if (brandFilter) {
              const brandData = cityData.find(d => d.brand_type === brandFilter);

              if (brandData) {
                const rate = Array.isArray(brandData.rate) ? brandData.rate[0] : brandData.rate;
                row.push(rate || "-");
              } else {
                row.push("-");
              }
            } else {
              const rate = cityData[0]?.rate;
              const value = Array.isArray(rate) ? rate[0] : rate;
              row.push(value || "-");
            }
          });

          rows.push(row);
        });

        return [headers, ...rows];
      };

      // 🔥 Create workbook
      const workbook = XLSX.utils.book_new();

      // 🔥 Add "Grocery - JPC" sheet
      if (foodItems.length > 0) {
        const jpcData = createWorksheetData(foodItems, "JPC");
        const jpcSheet = XLSX.utils.aoa_to_sheet(jpcData);
        jpcSheet["!cols"] = [{ wch: 10 }, { wch: 40 }, ...cityKeys.map(() => ({ wch: 15 }))];
        XLSX.utils.book_append_sheet(workbook, jpcSheet, "Grocery - JPC");
      }

      // 🔥 Add "Grocery - Non-JPC" sheet with merged headers
      if (foodItems.length > 0) {
        const { headers1, headers2, rows } = createWorksheetDataWithMerge(foodItems, "Non-JPC");
        const sheetData = [headers1, headers2, ...rows];
        const nonJpcSheet = XLSX.utils.aoa_to_sheet(sheetData);

        // ✅ Set column widths
        const minMaxCols = [];
        cityKeys.forEach(() => {
          minMaxCols.push({ wch: 12 }, { wch: 12 }); // Min column, Max column
        });
        nonJpcSheet["!cols"] = [{ wch: 10 }, { wch: 40 }, ...minMaxCols];

        // ✅ Merge cells for store names (row 0)
        const merges = [];
        // Merge S.No and Item Name vertically (rows 0-1)
        merges.push({ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }); // S.No
        merges.push({ s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }); // Item Name

        // Merge each city name across 2 columns (Min/Max)
        let colIndex = 2;
        cityKeys.forEach(() => {
          merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 1 } });
          colIndex += 2;
        });

        nonJpcSheet["!merges"] = merges;

        XLSX.utils.book_append_sheet(workbook, nonJpcSheet, "Grocery - Non-JPC");
      }

      // 🔥 Add "Grocery - Old" sheet (Unknown brand types) ✅ NEW SHEET
      if (foodItems.length > 0) {
        const { headers1, headers2, rows } = createWorksheetDataWithMerge(foodItems, "Unknown");
        const sheetData = [headers1, headers2, ...rows];
        const oldSheet = XLSX.utils.aoa_to_sheet(sheetData);

        // ✅ Set column widths
        const minMaxCols = [];
        cityKeys.forEach(() => {
          minMaxCols.push({ wch: 12 }, { wch: 12 }); // Min column, Max column
        });
        oldSheet["!cols"] = [{ wch: 10 }, { wch: 40 }, ...minMaxCols];

        // ✅ Merge cells for store names (row 0)
        const merges = [];
        // Merge S.No and Item Name vertically (rows 0-1)
        merges.push({ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }); // S.No
        merges.push({ s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }); // Item Name

        // Merge each city name across 2 columns (Min/Max)
        let colIndex = 2;
        cityKeys.forEach(() => {
          merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 1 } });
          colIndex += 2;
        });

        oldSheet["!merges"] = merges;

        XLSX.utils.book_append_sheet(workbook, oldSheet, "Grocery - Old");
      }

      // 🔥 Add "Grocery - Cooperative" sheet
      if (foodItems.length > 0) {
        const coopData = createWorksheetData(foodItems, "Cooperative");
        const coopSheet = XLSX.utils.aoa_to_sheet(coopData);
        coopSheet["!cols"] = [{ wch: 10 }, { wch: 40 }, ...cityKeys.map(() => ({ wch: 15 }))];
        XLSX.utils.book_append_sheet(workbook, coopSheet, "Grocery - Cooperative");
      }

// 🔥 Add "Veg, Meat, Dairy" sheet
      if (dailyItems.length > 0) {
        const dailyData = createWorksheetData(dailyItems);
        const dailySheet = XLSX.utils.aoa_to_sheet(dailyData);
        dailySheet["!cols"] = [{ wch: 10 }, { wch: 40 }, ...cityKeys.map(() => ({ wch: 15 }))];
        XLSX.utils.book_append_sheet(workbook, dailySheet, "Veg, Meat, Dairy");
      }
// 🔥 Add "Housekeeping - Non-JPC" sheet (with Min/Max merge like Grocery Non-JPC)
      const housekeepingItems = data.filter(item => item.category === "housekeeping");
      if (housekeepingItems.length > 0) {
        const { headers1, headers2, rows } = createWorksheetDataWithMerge(housekeepingItems, "Non-JPC");
        const sheetData = [headers1, headers2, ...rows];
        const hkNonJpcSheet = XLSX.utils.aoa_to_sheet(sheetData);

        const minMaxCols = [];
        cityKeys.forEach(() => {
          minMaxCols.push({ wch: 12 }, { wch: 12 });
        });
        hkNonJpcSheet["!cols"] = [{ wch: 10 }, { wch: 40 }, ...minMaxCols];

        const merges = [];
        merges.push({ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } });
        merges.push({ s: { r: 0, c: 1 }, e: { r: 1, c: 1 } });
        let colIndex = 2;
        cityKeys.forEach(() => {
          merges.push({ s: { r: 0, c: colIndex }, e: { r: 0, c: colIndex + 1 } });
          colIndex += 2;
        });
        hkNonJpcSheet["!merges"] = merges;

        XLSX.utils.book_append_sheet(workbook, hkNonJpcSheet, "Housekeeping - Non-JPC");
      }

      // 🔥 Add "Housekeeping - Cooperative" sheet
      if (housekeepingItems.length > 0) {
        const coopData = createWorksheetData(housekeepingItems, "Cooperative");
        const hkCoopSheet = XLSX.utils.aoa_to_sheet(coopData);
        hkCoopSheet["!cols"] = [{ wch: 10 }, { wch: 40 }, ...cityKeys.map(() => ({ wch: 15 }))];
        XLSX.utils.book_append_sheet(workbook, hkCoopSheet, "Housekeeping - Cooperative");
      }

      // 🔥 Download the Excel file
      XLSX.writeFile(workbook, "rate_comparison.xlsx");

      // 🔥 Download the Excel file
      XLSX.writeFile(workbook, "rate_comparison.xlsx");

      void 0;
    } else {
      void 0;
    }
  } catch (err) {
    void 0;
  }
};

  useEffect(() => {
    const fetchStores = async () => {
      const sessionAvailable = hasClientSession();
      if (!sessionAvailable) {
        void 0;
        return;
      }

      try {
        const response = await fetch(
          `${API_BASE_URL}/master/stores`,
          {
            method: 'GET',
            headers: {

              'Content-Type': 'application/json',
            },
          }
        );
        const result = await readJson(response);
        if (response.ok && !result.error) {
          // Convert object to array of {id, name} objects
          const storesArray = Object.entries(result.data || {}).map(([key, value]) => ({
            id: key,
            name: value
          }));
          setStoresData(storesArray);
          void 0;
        } else {
          void 0;
        }
      } catch (err) {
        void 0;
      }
    };

    fetchStores();
  }, []);
// ✅ Define fetchStoreStats with all filters (store, department, period)
const fetchStoreStats = async (storeId = null, deptId = null, period = null) => {
  const sessionAvailable = hasClientSession();
  if (!sessionAvailable) {
    void 0;
    return;
  }

  setStoreStatsLoading(true);

  try {
    // ✅ Build URL with ALL filters (store, department, period)
    let url = `${API_BASE_URL}/indent/report/stores?`;
    const params = [];

    if (storeId) params.push(`store=${storeId}`);
    if (deptId) params.push(`department=${deptId}`);
    if (period) params.push(`period=${period}`);

    url += params.join('&');

    void 0;

    const response = await fetch(url, {
      method: 'GET',
      headers: {

        'Content-Type': 'application/json',
      },
    });

    const result = await readJson(response);
    if (response.ok && !result.error) {
      setStoreStatsData(result.data || []);
      void 0;
    } else {
      void 0;
    }
  } catch (err) {
    void 0;
  } finally {
    setStoreStatsLoading(false);
  }
};

// ✅ Call on initial load (no filters)
useEffect(() => {
  fetchStoreStats();
}, []);

// ✅ Call on initial load
useEffect(() => {
  fetchStoreStats();
}, []);
  useEffect(() => {
    const fetchDefaultOrders = async () => {
      const sessionAvailable = hasClientSession();
      const userData = localStorage.getItem("user");
      if (!sessionAvailable || !userData) return;

      const user = JSON.parse(userData);

      try {
        let url = "";

        // ✅ Role-based default API call logic
 if (user.role === "rcs-admin") {
          url = `${API_BASE_URL}/indent/report/orders?period=thisMonth`;
        } else if (user.role === "department") {
          // Department default - no department/store filter
          url = `${API_BASE_URL}/indent/report/orders?period=thisMonth`;
        } else if (user.role === "dep-rep") {
          const loginDataRaw = localStorage.getItem("loginResponse");
          if (!loginDataRaw) return;

          const loginData = JSON.parse(loginDataRaw);
          const othersData = loginData?.user?.others ? JSON.parse(loginData.user.others) : {};
          const rangeData = othersData?.range || {};

          // ✅ Combine all branches for all types (dep-rep default)
          const allBranches = Object.values(rangeData).flat();
          const branchQuery = allBranches.map(b => `branch=${encodeURIComponent(b)}`).join("&");

          // ✅ Call both orders and recent indents APIs with all branches + period
          url = `${API_BASE_URL}/indent/report/orders?${branchQuery}&period=thisMonth`;

          // 🔹 Fetch orders first
          const response = await fetch(url, {
            method: "GET",
            headers: {

              "Content-Type": "application/json",
            },
          });
          const result = await readJson(response);

          if (!result.error) {
            setOrderReport(result.data || []);
            void 0;
          } else {
            void 0;
          }

          // 🔹 Fetch recent indents with same branch query + period
          const recentUrl = `${API_BASE_URL}/indent/report/recent?${branchQuery}&period=thisMonth&limit=5`;
          const recentRes = await fetch(recentUrl, {
            method: "GET",
            headers: {

              "Content-Type": "application/json",
            },
          });
          const recentResult = await readJson(recentRes);

          if (!recentResult.error) {
            setFilteredIndents(recentResult.data || []);
            void 0;
          } else {
            void 0;
          }
        } else {
          // All other roles (store-manager, etc.)
          url = `${API_BASE_URL}/indent/report/orders?period=thisMonth`;
        }
        const response = await fetch(url, {
          method: "GET",
          headers: {

            "Content-Type": "application/json",
          },
        });

        const result = await readJson(response);
        if (!result.error) {
          setOrderReport(result.data || []);
          void 0;
        } else {
          void 0;
        }
      } catch (err) {
        void 0;
      }
    };

    fetchDefaultOrders();
  }, []);
  const fetchFilteredData = async (storeId = null, deptId = null, period = null, branch = null) => {
    const sessionAvailable = hasClientSession();
    if (!sessionAvailable) return;

    try {
      // Build URL with ALL filters including branch
      let url = `${API_BASE_URL}/indent/report/orders?`;
      const params = [];

      if (storeId) params.push(`store=${storeId}`);
      if (deptId) params.push(`department=${deptId}`);
      if (period) params.push(`period=${period}`);
      // ✅ Branch handling logic for dep-rep
      if (userRole === "dep-rep") {
        const loginDataRaw = localStorage.getItem("loginResponse");
        const loginData = loginDataRaw ? JSON.parse(loginDataRaw) : null;
        const othersData = loginData?.user?.others ? JSON.parse(loginData.user.others) : {};
        const rangeData = othersData?.range || {};

        if (branch) {
          // 🔸 If specific branch selected → call only that branch
          params.push(`branch=${encodeURIComponent(branch)}`);
        } else if (selectedType) {
          // 🔸 If type selected → include only branches of that type
          const typeBranches = rangeData[selectedType] || [];
          params.push(typeBranches.map(b => `branch=${encodeURIComponent(b)}`).join("&"));
        } else {
          // 🔸 Default (no type/branch) → include all branches
          const allBranches = Object.values(rangeData).flat();
          params.push(allBranches.map(b => `branch=${encodeURIComponent(b)}`).join("&"));
        }
      } else if (branch) {
        // Other roles - keep normal behavior
        params.push(`branch=${encodeURIComponent(branch)}`);
      }

      url += params.join('&');

      // Fetch orders
      const ordersRes = await fetch(url, {
        method: 'GET',
        headers: {

          'Content-Type': 'application/json',
        },
      });
      const ordersResult = await readJson(ordersRes);
      if (!ordersResult.error) {
        setOrderReport(ordersResult.data || []);
      }

      // Fetch indents with same filters
      const indentsUrl = url.replace('/orders', '/recent?limit=5');
      const indentsRes = await fetch(indentsUrl, {
        method: 'GET',
        headers: {

          'Content-Type': 'application/json',
        },
      });
      const indentsResult = await readJson(indentsRes);
      if (!indentsResult.error) {
        setFilteredIndents(indentsResult.data || []);
      }
    } catch (err) {
      void 0;
    }
  };
  const [branchesList, setBranchesList] = useState([]);
  // 🔹 Type & Branch filters for dep-rep login
  const [typeOptions, setTypeOptions] = useState([]);
  const [selectedType, setSelectedType] = useState('');
  const [branchOptions, setBranchOptions] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');

  useEffect(() => {
    if (userRole === 'dep-rep') {
      const loginDataRaw = localStorage.getItem('loginResponse');
      void 0;

      try {
        const loginData = JSON.parse(loginDataRaw);
        void 0;

        // 🧠 Extract range from user.others (stringified JSON)
        const othersData = loginData?.user?.others
          ? JSON.parse(loginData.user.others)
          : {};
        const rangeData = othersData?.range || {};

        void 0;

        if (rangeData && typeof rangeData === 'object') {
          const types = Object.keys(rangeData);
          void 0;
          setTypeOptions(types);
        } else {
          void 0;
        }
      } catch (err) {
        void 0;
      }
    }
  }, [userRole]);

  useEffect(() => {
    // 🧠 Load rangeData from login response for dep-rep role
    const loginDataRaw = localStorage.getItem('loginResponse');
    if (!loginDataRaw) return;

    try {
      const loginData = JSON.parse(loginDataRaw);
      const othersData = loginData?.user?.others
        ? JSON.parse(loginData.user.others)
        : {};
      const rangeData = othersData?.range || {};

      void 0;

      const types = Object.keys(rangeData);
      setTypeOptions(types);
      localStorage.setItem('rangeData', JSON.stringify(rangeData));
    } catch (err) {
      void 0;
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">

      {/* Veg Price Alert Popup */}
      {showVegAlert && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 p-6 text-center">
            <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-7 h-7 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              </svg>
            </div>
            <p className="text-gray-900 font-semibold text-base mb-1">இன்றைய காய்கறி விலைகள் புதுப்பிக்கப்பட்டுள்ளதா என்பதை உறுதிப்படுத்தவும்</p>
            <p className="text-blue-600 font-semibold text-lg mb-6">Ensure that today's vegetables prices are updated.</p>
            <button
              onClick={() => {
                localStorage.setItem('showVegPriceAlert', `dismissed-${new Date().toDateString()}`);
                setShowVegAlert(false);
                navigate('/item', { state: { category: 'Veg, Meat, Dairy' } });
              }}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2.5 rounded-xl transition-colors"
            >
              Update Prices
            </button>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="bg-white/70 backdrop-blur-md border-b border-white/20 sticky top-0 z-10">
        <div className="px-8 py-1">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                Welcome back, {userName || 'User'}
              </h1>
              <p className="text-slate-600 mt-1 flex items-center gap-2">
                <Activity className="w-4 h-4" />
                Here's your system overview for today
              </p>
            </div>
            <div className="flex items-center gap-3">
              {userRole === 'rcs-admin' ? (
                <div className="flex gap-3">
{/* Stores Filter */}
<select
  value={selectedDistrict}
  onChange={(e) => {
    const selectedStoreName = e.target.value;
    setSelectedDistrict(selectedStoreName);

    const selectedStoreObj = storesData.find(store => store.name === selectedStoreName);

    if (selectedStoreObj) {
      fetchFilteredData(selectedStoreObj.id, selectedDepartment || null, selectedPeriod || null);
      // ✅ Fetch store stats with store filter
      setTimeout(() => fetchStoreStats(selectedStoreObj.id, selectedDepartment || null, selectedPeriod || null), 100);
    } else {
      setSelectedDepartment('');
      fetchFilteredData(null, null, selectedPeriod || null);
      // ✅ Fetch store stats without filters
      setTimeout(() => fetchStoreStats(null, null, selectedPeriod || null), 100);
    }
  }}
                    className="border border-gray-300 rounded-lg px-3 py-1 text-sm"
                  >
                    <option value="">All Stores</option>
                    {storesData.map((store) => (
                      <option key={store.id} value={store.name}>
                        {store.name}
                      </option>
                    ))}
                  </select>
{/* Department Filter */}
<select
  value={selectedDepartment}
  onChange={(e) => {
    const value = e.target.value;
    setSelectedDepartment(value);

    const selectedStoreObj = storesData.find(store => store.name === selectedDistrict);
    const storeId = selectedStoreObj ? selectedStoreObj.id : null;

    fetchFilteredData(storeId, value || null, selectedPeriod || null);
    // ✅ Fetch store stats with all current filters
    setTimeout(() => fetchStoreStats(storeId, value || null, selectedPeriod || null), 100);
  }}
                    className="border border-gray-300 rounded-lg px-3 py-1 text-sm"
                  >
                    <option value="">All Departments</option>
                    {departments.map((dept) => (
                      <option key={dept.id} value={dept.id}>
                        {dept.name}
                      </option>
                    ))}
                  </select>
                  {/* 🔹 Period Filter */}
                  <div className="relative inline-block">
                    <select
                      value={selectedPeriod}
                      onClick={(e) => {
                        // 👇 even if already selected, reopen calendar when clicking “Custom”
                        if (e.target.value === "custom") {
                          setShowCalendar(true);
                        }
                      }}
onChange={async (e) => {
  const value = e.target.value;
  setSelectedPeriod(value);

  if (value === "custom") {
    setShowCalendar(true);
    return;
  }

  setShowCalendar(false);
  setCustomLabel("");

  const sessionAvailable = hasClientSession();
  const selectedStoreObj = storesData.find(store => store.name === selectedDistrict);

  if (!sessionAvailable) return;

  try {
    // Build dynamic API URL
    let url = `${API_BASE_URL}/indent/report/orders?`;

    const params = [];
    if (selectedStoreObj) params.push(`store=${selectedStoreObj.id}`);
    if (selectedDepartment) params.push(`department=${selectedDepartment}`);
    if (value) params.push(`period=${value}`);

    url += params.join("&");

    const response = await fetch(url, {
      method: "GET",
      headers: {

        "Content-Type": "application/json",
      },
    });

    const result = await readJson(response);
    if (!result.error) {
      setOrderReport(result.data || []);
      // ✅ Fetch store stats with period filter
      setTimeout(() => fetchStoreStats(selectedStoreObj?.id || null, selectedDepartment || null, value), 100);
    } else {
      void 0;
    }
  } catch (err) {
    void 0;
  }
}}
                      className="border border-gray-300 rounded-lg px-3 py-1 text-sm cursor-pointer"
                    >
                      <option value="thisWeek">This Week</option>
                      <option value="lastWeek">Last Week</option>
                      <option value="thisMonth">This Month</option>
                      <option value="lastMonth">Last Month</option>
                      <option value="custom">Custom</option>
                    </select>

                    {/* 🗓️ Show selected range label if custom */}
                    {customLabel && selectedPeriod === "custom" && (
                      <span className="ml-3 text-sm text-gray-600 italic">{customLabel}</span>
                    )}

                    {/* 🗓️ Calendar Popup (aligned left) */}
                    {showCalendar && (
                      <div
                        ref={calendarRef}
                        className="absolute right-full mr-3 top-0 bg-white shadow-lg border border-gray-200 rounded-lg p-3 z-50"
                      >
                        <DateRange
                          editableDateInputs={true}
                          onChange={(item) => setDateRange([item.selection])}
                          moveRangeOnFirstSelection={false}
                          ranges={dateRange}
                          rangeColors={["#2563eb"]}
                          months={1}
                          direction="horizontal"
                          locale={enUS}
                        />

                        <div className="flex justify-end gap-2 mt-3">
<button
  onClick={() => {
    setShowCalendar(false);
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const startDate = formatDate(dateRange[0].startDate);
    const endDate = formatDate(dateRange[0].endDate);
    const customPeriod = `${startDate}:${endDate}`;

    setCustomLabel(`${startDate} - ${endDate}`);

    const selectedStoreObj = storesData.find(store => store.name === selectedDistrict);
    const storeId = selectedStoreObj ? selectedStoreObj.id : null;

    fetchFilteredData(storeId, selectedDepartment || null, customPeriod);
    // ✅ Fetch store stats with custom period
    setTimeout(() => fetchStoreStats(storeId, selectedDepartment || null, customPeriod), 100);
  }}
                            className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm hover:bg-blue-700"
                          >
                            Select
                          </button>
                          <button
                            onClick={() => {
                              setShowCalendar(false);
                              setSelectedPeriod("");
                              setCustomLabel("");
                            }}
                            className="border border-gray-300 px-3 py-1 rounded-md text-sm hover:bg-gray-100"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
           ) : userRole === 'rcs-store' ? (
  <div className="flex gap-3">
       {/* Department Filter */}
<select
  value={selectedDepartment}
onChange={(e) => {
  const value = e.target.value;
  setSelectedDepartment(value);
  fetchFilteredData(null, value || null, selectedPeriod || null);
  setTimeout(() => fetchStoreStats(null, value || null, selectedPeriod || null), 100);
}}
  className="border border-gray-300 rounded-lg px-3 py-1 text-sm"
>
      <option value="">All Departments</option>
      {departments.map((dept) => (
        <option key={dept.id} value={dept.id}>
          {dept.name}
        </option>
      ))}
    </select>
    {/* ✅ PERIOD FILTER FOR STORE LOGIN */}
    <div className="relative inline-block">
      <select
        value={selectedPeriod}
        onClick={(e) => {
          if (e.target.value === "custom") setShowCalendar(true);
        }}
        onChange={(e) => {
          const value = e.target.value;
          setSelectedPeriod(value);

          if (value !== "custom") {
            fetchFilteredData(null, null, value);
            setShowCalendar(false);
            setCustomLabel("");
          }
        }}
        className="border border-gray-300 rounded-lg px-3 py-1 text-sm cursor-pointer"
      >
        <option value="thisWeek">This Week</option>
        <option value="lastWeek">Last Week</option>
        <option value="thisMonth">This Month</option>
        <option value="lastMonth">Last Month</option>
        <option value="custom">Custom</option>
      </select>

      {/* Custom Range Calendar */}
      {showCalendar && (
        <div
          ref={calendarRef}
          className="absolute right-full mr-3 top-0 bg-white shadow-lg border border-gray-200 rounded-lg p-3 z-50"
        >
          <DateRange
            editableDateInputs={true}
            onChange={(item) => setDateRange([item.selection])}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            rangeColors={["#2563eb"]}
            months={1}
            direction="horizontal"
          />

          <div className="flex justify-end gap-2 mt-3">
<button
  onClick={() => {
    setShowCalendar(false);
    const start = dateRange[0].startDate.toISOString().split("T")[0];
    const end = dateRange[0].endDate.toISOString().split("T")[0];
    const customPeriod = `${start}:${end}`;
    setCustomLabel(`${start} - ${end}`);
    fetchFilteredData(null, selectedDepartment || null, customPeriod);
    // ✅ Fetch store stats with custom period + department
    setTimeout(() => fetchStoreStats(null, selectedDepartment || null, customPeriod), 100);
  }}
              className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm"
            >
              Select
            </button>

            <button
              onClick={() => {
                setShowCalendar(false);
                setSelectedPeriod("thisMonth");
                setCustomLabel("");
              }}
              className="border border-gray-300 px-3 py-1 rounded-md text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  </div>

              ) : userRole === 'dep-rep' ? (
                <>
                  <div className="flex gap-4 w-full">
                    {/* 🔹 Type Filter */}
                    <div className="flex-1 min-w-[200px]">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Type</label>
                      <select
                        value={selectedType}
                        onChange={async (e) => {
                          const selected = e.target.value;
                          setSelectedType(selected);

                          // 🔹 Get branches for selected type
                          const rangeData = JSON.parse(localStorage.getItem("rangeData")) || {};
                          const branches = rangeData[selected] || [];
                          void 0;
                          setBranchOptions(branches);
                          setSelectedBranch("");

                          // ✅ Immediately fetch Orders + Indents for that type's branches + period
                          if (branches.length > 0) {
                            const branchQuery = branches.map(b => `branch=${encodeURIComponent(b)}`).join("&");

                            const period = selectedPeriod || "thisMonth";

                            try {
                              // 🔸 Fetch Orders
                              const ordersRes = await fetch(
                                `${API_BASE_URL}/indent/report/orders?${branchQuery}&period=${period}`,
                                {
                                  method: "GET",
                                  headers: {

                                    "Content-Type": "application/json",
                                  },
                                }
                              );
                              const ordersResult = await readJson(ordersRes);
                              if (!ordersResult.error) {
                                setOrderReport(ordersResult.data || []);
                                void 0;
                              }

                              // 🔸 Fetch Recent Indents (same branch filter + period)
// 🔸 Fetch Recent Indents (same branch filter + period)
const indentsRes = await fetch(
  `${API_BASE_URL}/indent/report/recent?${branchQuery}&period=${period}&limit=5`,
  {
    method: "GET",
    headers: {

      "Content-Type": "application/json",
    },
  }
);                         const indentsResult = await readJson(indentsRes);
                              if (!indentsResult.error) {
                                setFilteredIndents(indentsResult.data || []);
                                void 0;
                              }
                            } catch (err) {
                              void 0;
                            }
                          }
                        }}
                        className="w-full border border-gray-300 rounded-lg p-2 h-[42px] bg-white focus:ring-2 focus:ring-blue-400 focus:outline-none"
                      >
                        <option value="">Select Type</option>
                        {typeOptions.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* 🔹 Branch Filter */}
                    <div className="flex-1 min-w-[200px]">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Branch</label>
                      <select
                        value={selectedBranch}
                        onChange={async (e) => {
                          const selected = e.target.value;
                          setSelectedBranch(selected);

                          if (!selected) return; // Skip if no branch selected


                          const period = selectedPeriod || "thisMonth";

                          try {
                            // ✅ Fetch Orders for selected branch + period
                            const ordersUrl = `${API_BASE_URL}/indent/report/orders?branch=${encodeURIComponent(selected)}&period=${period}`;
                            const ordersRes = await fetch(ordersUrl, {
                              method: "GET",
                              headers: {

                                "Content-Type": "application/json",
                              },
                            });
                            const ordersResult = await readJson(ordersRes);

                            if (!ordersResult.error) {
                              setOrderReport(ordersResult.data || []);
                              void 0;
                            } else {
                              void 0;
                            }

                            // ✅ Fetch Recent Indents for same branch + period
                            const indentsUrl = `${API_BASE_URL}/indent/report/recent?branch=${encodeURIComponent(selected)}&period=${period}&limit=5`;
                            const indentsRes = await fetch(indentsUrl, {
                              method: "GET",
                              headers: {

                                "Content-Type": "application/json",
                              },
                            });
                            const indentsResult = await readJson(indentsRes);

                            if (!indentsResult.error) {
                              setFilteredIndents(indentsResult.data || []);
                              void 0;
                            } else {
                              void 0;
                            }
                          } catch (err) {
                            void 0;
                          }
                        }}
                        disabled={!selectedType}
                        className="w-full border border-gray-300 rounded-lg p-2 h-[42px] bg-white disabled:bg-gray-100 focus:ring-2 focus:ring-blue-400 focus:outline-none"
                      >
                        <option value="">Select Branch</option>
                        {branchOptions.map((branch) => (
                          <option key={branch} value={branch}>
                            {branch}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* 🔹 Period Filter */}
                    <div className="flex-1 min-w-[200px]">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Period</label>
                      <div className="relative">
                        <select
                          value={selectedPeriod}
                          onClick={(e) => {
                            if (e.target.value === "custom") setShowCalendar(true);
                          }}
                          onChange={async (e) => {
                            const value = e.target.value;
                            setSelectedPeriod(value);

                            if (value === "custom") {
                              setShowCalendar(true);
                              return;
                            }

                            setShowCalendar(false);
                            setCustomLabel("");

                            // Trigger API call with current filters + new period
                            const loginDataRaw = localStorage.getItem("loginResponse");
                            const loginData = loginDataRaw ? JSON.parse(loginDataRaw) : null;
                            const othersData = loginData?.user?.others ? JSON.parse(loginData.user.others) : {};
                            const rangeData = othersData?.range || {};

                            let branchQuery = "";
                            if (selectedBranch) {
                              branchQuery = `branch=${encodeURIComponent(selectedBranch)}`;
                            } else if (selectedType) {
                              const typeBranches = rangeData[selectedType] || [];
                              branchQuery = typeBranches.map(b => `branch=${encodeURIComponent(b)}`).join("&");
                            } else {
                              const allBranches = Object.values(rangeData).flat();
                              branchQuery = allBranches.map(b => `branch=${encodeURIComponent(b)}`).join("&");
                            }


                            try {
                              // Fetch Orders
                              const ordersRes = await fetch(
                                `${API_BASE_URL}/indent/report/orders?${branchQuery}&period=${value}`,
                                {
                                  method: "GET",
                                  headers: {

                                    "Content-Type": "application/json",
                                  },
                                }
                              );
                              const ordersResult = await readJson(ordersRes);
                              if (!ordersResult.error) {
                                setOrderReport(ordersResult.data || []);
                              }

                              // Fetch Indents
                              const indentsRes = await fetch(
                                `${API_BASE_URL}/indent/report/recent?${branchQuery}&period=${value}&limit=5`,
                                {
                                  method: "GET",
                                  headers: {

                                    "Content-Type": "application/json",
                                  },
                                }
                              );
                              const indentsResult = await readJson(indentsRes);
                              if (!indentsResult.error) {
                                setFilteredIndents(indentsResult.data || []);
                              }
                            } catch (err) {
                              void 0;
                            }
                          }}
                          className="w-full border border-gray-300 rounded-lg p-2 h-[42px] bg-white focus:ring-2 focus:ring-blue-400 focus:outline-none"
                        >
                          <option value="thisWeek">This Week</option>
                          <option value="lastWeek">Last Week</option>
                          <option value="thisMonth">This Month</option>
                          <option value="lastMonth">Last Month</option>
                          <option value="custom">Custom</option>
                        </select>

                        {/* Calendar for custom range */}
                        {showCalendar && (
                          <div
                            ref={calendarRef}
                            className="absolute right-0 mt-2 bg-white shadow-lg border border-gray-200 rounded-lg p-3 z-50"
                          >
                            <DateRange
                              editableDateInputs={true}
                              onChange={(item) => setDateRange([item.selection])}
                              moveRangeOnFirstSelection={false}
                              ranges={dateRange}
                              rangeColors={["#2563eb"]}
                              months={1}
                              direction="horizontal"
                              locale={enUS}
                            />
                            <div className="flex justify-end gap-2 mt-3">
                              <button
                                onClick={async () => {
                                  setShowCalendar(false);
                     // Format dates correctly without timezone issues
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const startDate = formatDate(dateRange[0].startDate);
const endDate = formatDate(dateRange[0].endDate);
                                  const customPeriod = `${startDate}:${endDate}`;
                                  setCustomLabel(`${startDate} - ${endDate}`);

                                  const loginDataRaw = localStorage.getItem("loginResponse");
                                  const loginData = loginDataRaw ? JSON.parse(loginDataRaw) : null;
                                  const othersData = loginData?.user?.others ? JSON.parse(loginData.user.others) : {};
                                  const rangeData = othersData?.range || {};

                                  let branchQuery = "";
                                  if (selectedBranch) {
                                    branchQuery = `branch=${encodeURIComponent(selectedBranch)}`;
                                  } else if (selectedType) {
                                    const typeBranches = rangeData[selectedType] || [];
                                    branchQuery = typeBranches.map(b => `branch=${encodeURIComponent(b)}`).join("&");
                                  } else {
                                    const allBranches = Object.values(rangeData).flat();
                                    branchQuery = allBranches.map(b => `branch=${encodeURIComponent(b)}`).join("&");
                                  }

try {
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const startDate = formatDate(dateRange[0].startDate);
  const endDate = formatDate(dateRange[0].endDate);
  const customPeriod = `${startDate}:${endDate}`;

  const ordersRes = await fetch(
    `${API_BASE_URL}/indent/report/orders?${branchQuery}&period=${customPeriod}`,
    { method: "GET", headers: {  "Content-Type": "application/json" } }
  );
  const ordersResult = await readJson(ordersRes);
  if (!ordersResult.error) setOrderReport(ordersResult.data || []);

  const indentsRes = await fetch(
    `${API_BASE_URL}/indent/report/recent?${branchQuery}&period=${customPeriod}&limit=5`,
    { method: "GET", headers: {  "Content-Type": "application/json" } }
  );
  const indentsResult = await readJson(indentsRes);
  if (!indentsResult.error) setFilteredIndents(indentsResult.data || []);
} catch (err) {
  void 0;
}
                                }}
                                className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm hover:bg-blue-700"
                              >
                                Select
                              </button>
                              <button
                                onClick={() => {
                                  setShowCalendar(false);
                                  setSelectedPeriod("thisMonth");
                                  setCustomLabel("");
                                }}
                                className="border border-gray-300 px-3 py-1 rounded-md text-sm hover:bg-gray-100"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        )}

                        {customLabel && selectedPeriod === "custom" && (
                          <span className="text-xs text-gray-600 italic mt-1 block">{customLabel}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : userRole === 'department' ? (
                <div className="flex gap-3">
                  {/* Branch Filter */}
                  {/* <select
      value={selectedBranch}
      onChange={(e) => {
        const branchName = e.target.value;
        setSelectedBranch(branchName);

        // ✅ Fetch filtered data with branch + period only
        fetchFilteredData(null, null, selectedPeriod || null, branchName || null);
      }}
      className="border border-gray-300 rounded-lg px-3 py-1 text-sm"
    >
      <option value="">All Branches</option>
      {branchesList.map((branch, idx) => (
        <option key={idx} value={branch.branch}>
          {branch.branch} ({branch.branchType})
        </option>
      ))}
    </select> */}

                  {/* Period Filter */}
                  <div className="relative inline-block">
                    <select
                      value={selectedPeriod}
                      onClick={(e) => {
                        if (e.target.value === "custom") setShowCalendar(true);
                      }}
                      onChange={async (e) => {
                        const value = e.target.value;
                        setSelectedPeriod(value);

                        if (value === "custom") {
                          setShowCalendar(true);
                          return;
                        }

                        setShowCalendar(false);
                        setCustomLabel("");

                        // ✅ Period + branch only
                        fetchFilteredData(null, null, value || null, selectedBranch || null);
                      }}
                      className="border border-gray-300 rounded-lg px-3 py-1 text-sm cursor-pointer"
                    >
                      <option value="">All Periods</option>
                      <option value="thisWeek">This Week</option>
                      <option value="lastWeek">Last Week</option>
                      <option value="thisMonth">This Month</option>
                      <option value="lastMonth">Last Month</option>
                      <option value="custom">Custom</option>
                    </select>

                    {customLabel && selectedPeriod === "custom" && (
                      <span className="ml-3 text-sm text-gray-600 italic">{customLabel}</span>
                    )}

                    {/* Calendar Popup */}
                    {showCalendar && (
                      <div
                        ref={calendarRef}
                        className="absolute right-full mr-3 top-0 bg-white shadow-lg border border-gray-200 rounded-lg p-3 z-50"
                      >
                        <DateRange
                          editableDateInputs={true}
                          onChange={(item) => setDateRange([item.selection])}
                          moveRangeOnFirstSelection={false}
                          ranges={dateRange}
                          rangeColors={["#2563eb"]}
                          months={1}
                          direction="horizontal"
                          locale={enUS}
                        />

                        <div className="flex justify-end gap-2 mt-3">
                          <button
                            onClick={() => {
                              setShowCalendar(false);
              // Format dates correctly without timezone issues
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const startDate = formatDate(dateRange[0].startDate);
const endDate = formatDate(dateRange[0].endDate);
                              const customPeriod = `${startDate}:${endDate}`;
                              setCustomLabel(`${startDate} - ${endDate}`);

                              // ✅ Only period + branch
                              fetchFilteredData(null, null, customPeriod, selectedBranch || null);
                            }}
                            className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm hover:bg-blue-700"
                          >
                            Select
                          </button>
                          <button
                            onClick={() => {
                              setShowCalendar(false);
                              setSelectedPeriod("");
                              setCustomLabel("");
                            }}
                            className="border border-gray-300 px-3 py-1 rounded-md text-sm hover:bg-gray-100"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="bg-gray-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                  User
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="p-8">
        {/* Summary Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
          {summaryCards.map((card, idx) => (
            <div
              key={idx}
              onClick={() => handleCardClick(card.key)}
              className={`group relative border border-white/20 rounded-3xl p-4 shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer ${card.bgColor || 'bg-white/80'}`}
            >
              <div className="flex items-center justify-between">
                {/* Left - Icon */}
                <div
                  className={`p-3 rounded-2xl bg-white shadow-sm group-hover:scale-110 transition-transform duration-300`}
                >
                  {card.icon}
                </div>

                {/* Right - Title */}
                <div className="text-right">
                  <p className="text-base font-semibold text-slate-800">{card.title}</p>
                </div>
              </div>
              {/* Divider */}
              <div className="mt-2 border-t border-gray-200"></div>
              {/* Value Section */}
              <div className="mt-2">
                {typeof card.value === "string" && card.value.includes("/") ? (
                  <div>
                    <p className="text-sm text-gray-600 mb-1">
                      {card.key === "approved"
                        ? "Pending / Received"
                        : card.key === "dispatch"
                          ? "In Transit"
                          : card.key === "received"
                            ? "Delivered"
                            : card.key === "pc"
                              ? "Pending / Completed"
                              : card.key === "invoice"
                                ? "Pending / PC Orders"
                                : card.key === "payment"
                                  ? "Pending / Invoice Orders"
                                  : ""}
                    </p>
                    <p className="text-2xl font-bold text-slate-800">
                      <span>{card.value.split("/")[0]}</span>
                      <span className="text-gray-400 text-sm font-normal ml-1">
                        /{card.value.split("/")[1]}
                      </span>
                    </p>
                  </div>
                ) : (
                  // Fallback for cards that only have a single number (no slash)
                  <>
                    <p className="text-sm text-gray-600 mb-1">
                      {card.key === "dispatch"
                        ? "In Transit"
                        : card.key === "received"
                          ? " Delivered"
                          : ""}
                    </p>
                    <p className="text-2xl font-bold text-slate-800">
                      {card.value.toLocaleString()}
                    </p>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
{/* Store Details Widget for ind-apr */}
{(userRole === 'ind-apr' || userRole === 'st-ind-apr') && (
  <div className="mb-6">
    <div className="bg-white/80 backdrop-blur-sm border border-white/20 rounded-3xl shadow-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-slate-800 flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-xl">
            <Building2 className="w-6 h-6 text-blue-600" />
          </div>
          Store Information
        </h3>
      </div>

      {indAprStoreLoading ? (
        <div className="flex items-center justify-center py-8">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          <p className="ml-3 text-gray-600">Loading store information...</p>
        </div>
      ) : indAprStoreInfo ? (
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          {/* Store Name Card */}
          <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-200">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <Building2 className="w-5 h-5 text-white" />
              </div>
              <span className="text-xs text-blue-600 font-medium uppercase">Store Name</span>
            </div>
            <p className="text-sm font-bold text-blue-900 truncate" title={indAprStoreInfo.name}>{indAprStoreInfo.name || 'N/A'}</p>
            <p className="text-xs text-blue-700 mt-1 truncate" title={indAprStoreInfo.brand}>{indAprStoreInfo.brand || ''}</p>
          </div>

          {/* Contact Person Card */}
          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-4 border border-purple-200">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <span className="text-xs text-purple-600 font-medium uppercase">Contact Person</span>
            </div>
            <p className="text-sm font-bold text-purple-900 truncate" title={indAprStoreInfo.manager}>{indAprStoreInfo.manager || 'N/A'}</p>
          </div>

          {/* District Card */}
          <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border border-green-200">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <span className="text-xs text-green-600 font-medium uppercase">District</span>
            </div>
            <p className="text-sm font-bold text-green-900">{indAprStoreInfo.district || 'N/A'}</p>
            <p className="text-xs text-green-700 mt-1 truncate" title={indAprStoreInfo.store}>{indAprStoreInfo.store || ''}</p>
          </div>

          {/* Contact Card */}
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-4 border border-orange-200">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 bg-orange-600 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <span className="text-xs text-orange-600 font-medium uppercase">Contact</span>
            </div>
            <p className="text-sm font-bold text-orange-900">{indAprStoreInfo.contact || 'N/A'}</p>
          </div>

          {/* Address Card */}
          <div className="bg-gradient-to-br from-slate-50 to-gray-50 rounded-xl p-4 border border-slate-200">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 bg-slate-600 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <span className="text-xs text-slate-600 font-medium uppercase">Address</span>
            </div>
            <p className="text-xs font-medium text-slate-800 leading-tight line-clamp-3" title={indAprStoreInfo.address}>{indAprStoreInfo.address || 'N/A'}</p>
          </div>
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <Building2 className="w-12 h-12 mx-auto mb-3 text-gray-400" />
          <p>No store information available</p>
        </div>
      )}
    </div>
  </div>
)}
 {/* Main Content Grid - Three Equal Widgets */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {/* Recent Indents */}
          {recentIndents.length > 0 && (
            <div className="col-span-1">
              <div className="bg-white/80 backdrop-blur-sm border border-white/20 rounded-3xl shadow-xl p-6 h-full">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-bold text-slate-800 flex items-center gap-3">
                    <div className="p-2 bg-emerald-100 rounded-xl">
                      <Clock className="w-5 h-5 text-emerald-600" />
                    </div>
                    Recent Indents
                  </h3>
                </div>

                <div className="space-y-3 max-h-[420px] overflow-y-auto pr-1">
                  {(userRole === 'dep-rep' ? filteredIndents : recentIndents)
                    .map((indent, idx) => (
                      <div
                        key={indent.id}
                        className="p-3 rounded-lg bg-gradient-to-br from-white to-slate-50 border border-slate-200 shadow-sm hover:shadow-md transition-all duration-200"
                      >
                        <div className="flex justify-between items-center mb-2">
                          <span className="text-xs font-semibold text-slate-600">#{idx + 1}</span>
                          <span className={`px-2 py-0.5 rounded-full text-xs font-medium border ${getStatusColor(indent.status)}`}>
                            {indent.status === 'Approved' ? 'Received' : indent.status}
                          </span>
                        </div>
                        <div className="space-y-1">
                          <div className="flex justify-between text-xs">
                            <span className="text-slate-600">Type:</span>
                            <span className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded-md font-medium">
                              {indent.type}
                            </span>
                          </div>
                          <div className="flex justify-between text-xs">
                            <span className="text-slate-600">Branch:</span>
                            <span className="font-medium text-slate-800">{indent.branch}</span>
                          </div>
                          <div className="flex justify-between text-xs">
                            <span className="text-slate-600">Store:</span>
                            <span className="font-medium text-slate-800">{indent.store}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          )}

{/* Store Stats Widget */}
{(userRole === 'rcs-admin' || userRole === 'department') && (
            <div className="col-span-1">
            <div className="bg-white/80 backdrop-blur-sm border border-white/20 rounded-3xl shadow-xl p-6 h-full">
<div className="flex items-center justify-between mb-6">
  <h3 className="text-xl font-bold text-slate-800 flex items-center gap-3">
    <div className="p-2 bg-indigo-100 rounded-xl">
      <Building2 className="w-5 h-5 text-indigo-600" />
    </div>
Order despatch monitoring

  </h3>

  <div className="flex items-center gap-2">
    {/* Excel Export Button */}
    <button
      onClick={downloadStoreStatsExcel}
      title="Export Store Stats"
      className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2 shadow"
    >
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v16h16V4H4zm4 8h8m-8 4h5"
        />
      </svg>
    </button>
  </div>
</div>
{storeStatsData && Array.isArray(storeStatsData) && storeStatsData.length > 0 ? (
  <div className="max-h-[420px] overflow-y-auto">
    {/* Table Header */}
{/* Table Header */}
<div className="sticky top-0 bg-white border-b border-gray-200 pb-2 mb-3 z-10">
  <div className="flex items-center gap-3 px-3">
    <div className="w-10 flex-shrink-0"></div>
    <div className="flex-1 min-w-0">
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-semibold text-gray-600">Store</span>
        <div className="flex items-center gap-6 flex-shrink-0">
          <div
            className="text-center cursor-pointer hover:opacity-80 transition-opacity w-12"
            onClick={() => {
              setStoreStatsSortBy(storeStatsSortBy === 'pending-desc' ? 'pending-asc' : 'pending-desc');
            }}
          >
            <p className="text-xs font-semibold text-gray-600 flex items-center justify-center gap-1">
              Pending
              <span className="text-[10px]">
                {storeStatsSortBy === 'pending-desc' ? '▼' : storeStatsSortBy === 'pending-asc' ? '▲' : ''}
              </span>
            </p>
          </div>
          <div
            className="text-center cursor-pointer hover:opacity-80 transition-opacity w-20"
            onClick={() => {
              setStoreStatsSortBy(storeStatsSortBy === 'dispatched-desc' ? 'dispatched-asc' : 'dispatched-desc');
            }}
          >
            <p className="text-xs font-semibold text-gray-600 flex items-center justify-center gap-1">
              Dispatched
              <span className="text-[10px]">
                {storeStatsSortBy === 'dispatched-desc' ? '▼' : storeStatsSortBy === 'dispatched-asc' ? '▲' : ''}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    {/* Table Rows */}
    <div className="space-y-3 pr-1">
      {storeStatsData
        .filter((item) => item.store !== null)
        .sort((a, b) => {
          const pendingA = parseInt(a.received) || 0;
          const pendingB = parseInt(b.received) || 0;
          const dispatchedA = parseInt(a.dispatched) || 0;
          const dispatchedB = parseInt(b.dispatched) || 0;

          switch (storeStatsSortBy) {
            case 'pending-desc':
              return pendingB - pendingA;
            case 'pending-asc':
              return pendingA - pendingB;
            case 'dispatched-desc':
              return dispatchedB - dispatchedA;
            case 'dispatched-asc':
              return dispatchedA - dispatchedB;
            default:
              return pendingB - pendingA;
          }
        })
.map((store, idx) => {
  let storeData = {};
  try {
    storeData = typeof store.store === 'string' ? JSON.parse(store.store) : store.store;
  } catch (e) {}
  const storeName = storeData?.name || store.store || 'Unknown Store';

  return (
    <div
      key={idx}
      onClick={() => {
        const params = new URLSearchParams();
        params.append('tab', 'approved');
        params.append('store', storeName);
        if (selectedPeriod) params.append('period', selectedPeriod);
        navigate(`/indent-request?${params.toString()}`);
      }}
      className="cursor-pointer flex items-center justify-between px-3 py-2 rounded-lg border border-slate-200 hover:bg-slate-50 transition-all duration-150"
    >
      <div className="min-w-0 flex-1">
        <span className="text-xs font-semibold text-indigo-700 block truncate">{store.code || 'No Code'}</span>
        <span className="text-xs text-slate-500 truncate block">{storeName}</span>
        {storeData?.mobile && (
          <span className="text-xs text-slate-400 block">{storeData.mobile}</span>
        )}
      </div>
      <div className="flex items-center gap-4 flex-shrink-0 ml-2">
        <span className="font-semibold text-orange-600 text-sm w-8 text-center">{store.received || 0}</span>
        <span className="font-semibold text-green-600 text-sm w-10 text-center">{store.dispatched || 0}</span>
      </div>
    </div>
  );
})}
    </div>
  </div>
) : storeStatsLoading ? (
                <div className="flex items-center justify-center py-8">
                  <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : (
                <div className="flex items-center justify-center py-8">
                  <div className="w-8 h-8 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
                </div>
              )}
</div>
          </div>
          )}
          {/* Store Sidebar */}
        {/* Store Sidebar - Only for rcs-admin, department, rcs-store */}
{(userRole === 'rcs-admin' || userRole === 'department' || userRole === 'rcs-store') && (
  <div className="col-span-1">
    <div className="bg-white/80 backdrop-blur-sm border border-white/20 rounded-3xl shadow-xl p-6 h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-slate-800 flex items-center gap-3">
          <div className="p-2 bg-purple-100 rounded-xl">
            <Package className="w-5 h-5 text-purple-600" />
          </div>
          Store Data
        </h3>

        {userRole !== "indent" && userRole !== "ind-apr" && userRole !== "st-ind-apr" && (
          <button
            onClick={handlePriceItemsExcel}
            title="Export Price Items"
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2 shadow"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v16h16V4H4zm4 8h8m-8 4h5"
              />
            </svg>
          </button>
        )}
      </div>

      {storeData && Array.isArray(storeData) && storeData.length > 0 ? (
        <div className="space-y-3 max-h-[420px] overflow-y-auto pr-1">
          {storeData
            .filter((item) => item.rate > 0 || item.package > 0 || item.offer > 0)
            .map((store, idx) => (
              <div
                key={idx}
                onClick={() => handleStoreClick(store.name, store.store)}
                className="cursor-pointer p-3 rounded-lg bg-gradient-to-br from-white to-slate-50 border border-slate-200 shadow-sm hover:shadow-md transition-all duration-200"
              >
                <div className="flex justify-between items-center mb-1">
                  <h3 className="text-sm font-semibold text-indigo-700">
                    {store.store}
                  </h3>
                  <span
                    className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-md font-medium cursor-pointer hover:bg-blue-200"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleBranchClick(store);
                    }}
                  >
                    {userRole === "rcs-admin"
                      ? store.name || "No Name"
                      : store.branches
                        ? `${store.branches.length} Branches`
                        : "No Branches"}
                  </span>
                </div>
                {userRole !== 'dep-rep' && (
                  <div className="flex justify-between text-xs text-slate-800">
                    <span>
                      Offer: <span className="font-medium">{store.offer}</span>
                    </span>
                    <span>
                      Items Priced: <span className="font-medium">{store.rate}</span>
                    </span>
                    <span>
                      Package: <span className="font-medium">{store.package}</span>
                    </span>
                  </div>
                )}
              </div>
            ))}
        </div>
      ) : (
        <p className="text-slate-500 text-sm">No store data available.</p>
      )}
    </div>
  </div>
)}
        </div>

        {isModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl transform transition-all duration-300 ease-out scale-100">
              {/* Header */}
              <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-6 rounded-t-xl">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h3M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                    <h2 className="text-2xl font-bold">
                      {selectedStore || 'Store Details'}
                    </h2>
                  </div>
                  <button
                    className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-colors duration-200"
                    onClick={() => setIsModalOpen(false)}
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                  <div className="overflow-auto max-h-[500px]">
                    <table className="w-full text-sm table-fixed">
                      <thead className="bg-gradient-to-r from-gray-50 to-gray-100 sticky top-0 z-10 border-b border-gray-200">
                        <tr>
                          <th className="px-6 py-3 font-semibold text-gray-800 w-20">
                            <div className="flex items-center gap-2">
                              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
                                </svg>
                              </div>
                              <span className="hidden sm:inline"></span>
                            </div>
                          </th>
                          <th className="px-6 py-3 font-semibold text-gray-800 text-left w-auto">
                            <div className="flex items-center gap-2">
                              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                                <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                </svg>
                              </div>
                              <span>Item Name</span>
                            </div>
                          </th>
                          <th className="px-6 py-3 font-semibold text-gray-800 text-left w-32">
                            <div className="flex items-center gap-2">
                              <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                                <span className="text-orange-600 font-bold text-sm">₹</span>
                              </div>
                              <span>Rate</span>
                            </div>
                          </th>
                          <th className="px-6 py-3 font-semibold text-gray-800 text-left w-32">
                            <div className="flex items-center gap-2">
                              <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                                <svg className="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                </svg>
                              </div>
                              <span>Pack Size</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {storeDetails.items.map((item, idx) => (
                          <tr key={item.id} className="hover:bg-gray-50 transition-all duration-200 group">
                            <td className="px-6 py-3">
                              <div className="flex items-center justify-center">
                                <div className="w-8 h-8 bg-blue-50 group-hover:bg-blue-100 rounded-full flex items-center justify-center text-sm font-semibold text-blue-700 transition-all duration-200 border border-blue-200">
                                  {idx + 1}
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-3">
                              <div className="flex items-center gap-3">
                                <div className="w-2 h-2 flex-shrink-0"></div>
                                <span className="text-gray-900 font-medium">
                                  {item.name}
                                  {item.unit && (
                                    <span className="ml-2 text-blue-600 text-sm font-medium">({item.unit})</span>
                                  )}
                                </span>
                              </div>
                            </td>
                            <td className="px-6 py-3">
                              <span className="text-green-700 font-semibold">₹{item.rate}</span>
                            </td>
                            <td className="px-6 py-3">
                              <span className="text-purple-700 font-medium">{item.pack}{item.pack_unit}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Footer */}
                <div className="mt-6 flex justify-between items-center">
                  <div className="bg-gray-50 px-6 py-3 rounded-lg border border-gray-200 flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <span className="text-sm font-medium">
                      Total Items: {storeDetails.items.length}
                    </span>
                  </div>

                  <button
                    onClick={downloadStoreExcel}
                    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v16h16V4H4zm4 8h8m-8 4h5" />
                    </svg>
                    Download Excel
                  </button>

                </div>

              </div>
            </div>
          </div>
        )}
      </div>
      {/* Branches Modal */}
      {branchesModalOpen && selectedBranches && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl transform transition-all duration-300 ease-out scale-100">
            {/* Header */}
            <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white p-6 rounded-t-xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Building2 className="w-7 h-7 text-white" />
                  <h2 className="text-2xl font-bold">
                    {selectedBranches.storeName}
                  </h2>
                </div>
                <button
                  className="text-white hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition-colors duration-200"
                  onClick={() => setBranchesModalOpen(false)}
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="p-6">
              <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                <div className="overflow-auto max-h-[400px]">
                  <table className="w-full text-sm">
                    <thead className="bg-gradient-to-r from-gray-50 to-gray-100 sticky top-0 z-10 border-b border-gray-200">
                      <tr>
                        <th className="px-6 py-3 font-semibold text-gray-800 text-left">S.No</th>
                        <th className="px-6 py-3 font-semibold text-gray-800 text-left">Type</th>
                        <th className="px-6 py-3 font-semibold text-gray-800 text-left">Branch Name</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {selectedBranches.branches.map((branch, idx) => (
                        <tr key={branch.id} className="hover:bg-gray-50 transition-all duration-200 group">
                          <td className="px-6 py-3">
                            <div className="w-8 h-8 bg-blue-50 group-hover:bg-blue-100 rounded-full flex items-center justify-center text-sm font-semibold text-blue-700 transition-all duration-200 border border-blue-200">
                              {idx + 1}
                            </div>
                          </td>
                          <td className="px-6 py-3">
                            <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-xs font-medium">
                              {branch.type}
                            </span>
                          </td>
                          <td className="px-6 py-3">
                            <span className="text-gray-900 font-medium">
                              {branch.branch}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Footer */}
              <div className="mt-6 flex justify-between items-center">
                <div className="bg-gray-50 px-6 py-3 rounded-lg border border-gray-200 flex items-center gap-2">
                  <Building2 className="w-5 h-5 text-gray-600" />
                  <span className="text-sm font-medium">
                    Total Branches: {selectedBranches.branches.length}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default SimplifiedDashboard;